export const BrandS = ({ className = "h-full w-full" }) => (
  <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="bms" x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F97316" />
        <stop offset="1" stopColor="#C2410C" />
      </linearGradient>
    </defs>
    <rect width="48" height="48" rx="13" fill="url(#bms)" />
    <path
      d="M29.5 16.2c-.9-1.5-3-2.4-5.7-2.4-4 0-6.9 2-6.9 5.3 0 6.7 14.4 3.6 14.4 8.9 0 2.3-2.3 3.9-5.7 3.9-3 0-5.4-1.1-6.7-2.9"
      stroke="#fff"
      strokeWidth="3.6"
      strokeLinecap="round"
    />
    <circle cx="34.6" cy="15.4" r="2.5" fill="#FCD34D" />
  </svg>
);

export const BrandWordmark = ({ dark = false }) => (
  <span className="leading-none select-none">
    <span className={`block font-heading text-lg font-extrabold tracking-tight ${dark ? "text-white" : "text-teal-950"}`}>
      MARHINE<span className="text-teal-500">.</span>
    </span>
    <span className={`block text-[9px] font-bold uppercase tracking-[0.22em] ${dark ? "text-teal-200" : "text-teal-600"}`}>
      Source · Trade · Grow
    </span>
  </span>
);
